import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { AutomationRulesCardLayout } from '../styled/automation-rules.style';
import { DeleteOptionParams } from '../types/automation-rules.type';
import { ConditionCard } from '../ui-components/condition-card.component';

interface TriggerOptionItemProps {
    id: number;
    content: React.ReactElement;
    index: number;
    externalOptions: unknown[];
    onDeleteOptionHandler: (data: DeleteOptionParams) => () => void;
}

export const TriggerOptionItem = React.memo((props: TriggerOptionItemProps) => {
    const { content, id, index, externalOptions, onDeleteOptionHandler } = props;
    const { t } = useTranslation();

    const clonedContent = React.useMemo(() => React.cloneElement(content, { externalOptions }), [content]);
    return (
        <AutomationRulesCardLayout key={id} className="col-dir" padding="0">
            {index > 0 && (
                <PocTypography variant="subtitle2">
                    {t('settings.system.automation-rules.logical-operators.and')}
                </PocTypography>
            )}
            <ConditionCard content={clonedContent} id={id} onDeleteOptionHandler={onDeleteOptionHandler} />
        </AutomationRulesCardLayout>
    );
});
